import React from 'react';

import { FocusSvg, Ring } from './FocusIcon.styles';

/**
 * The 64x64 autofocus mark for the Pulse "Calibrating" card. The four corner brackets are
 * static (the Figma "focus" glyph, drawn with `fill: currentColor`); the reticle ring
 * continuously racks in and out of focus, blurring then snapping sharp like a camera lens
 * settling on its subject (and blooming a soft glow on the lock frames). Purely decorative
 * (`aria-hidden`); honours reduced motion (the ring holds a static, sharp frame).
 */
export const FocusIcon = (): React.ReactElement => (
  <FocusSvg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
    {/* Corner brackets (top-left, bottom-left, top-right, bottom-right). */}
    <path d="M15,190.667c-8.284,0-15-6.716-15-15V95.333C0,42.767,42.767,0,95.333,0h80.334c8.284,0,15,6.716,15,15s-6.716,15-15,15H95.333C59.309,30,30,59.309,30,95.333v80.334C30,183.951,23.284,190.667,15,190.667z" />
    <path d="M175.667,512H95.333C42.767,512,0,469.233,0,416.667v-80.334c0-8.284,6.716-15,15-15s15,6.716,15,15v80.334C30,452.691,59.309,482,95.333,482h80.334c8.284,0,15,6.716,15,15S183.951,512,175.667,512z" />
    <path d="M497,190.667c-8.284,0-15-6.716-15-15V95.333C482,59.309,452.691,30,416.667,30h-80.334c-8.284,0-15-6.716-15-15s6.716-15,15-15h80.334C469.233,0,512,42.767,512,95.333v80.334C512,183.951,505.284,190.667,497,190.667z" />
    <path d="M416.667,512h-80.334c-8.284,0-15-6.716-15-15s6.716-15,15-15h80.334C452.691,482,482,452.691,482,416.667v-80.334c0-8.284,6.716-15,15-15s15,6.716,15,15v80.334C512,469.233,469.233,512,416.667,512z" />
    {/* Reticle ring (the part that blur-racks focus). */}
    <Ring d="M256,351.333c-52.566,0-95.333-42.767-95.333-95.333s42.767-95.333,95.333-95.333s95.333,42.767,95.333,95.333S308.566,351.333,256,351.333z M256,190.667c-36.024,0-65.333,29.309-65.333,65.333s29.309,65.333,65.333,65.333s65.333-29.309,65.333-65.333S292.024,190.667,256,190.667z" />
  </FocusSvg>
);

export default FocusIcon;
